import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { LanguageProvider } from './language-provider';


@Directive({
    selector: '[appTranslate]',
    standalone: true,
})
export class TranslateDirective implements OnInit {


    @Input() appTranslate: any;


    constructor(public provider: LanguageProvider, private el?: ElementRef) {
    }

    ngOnInit() {
        this.translate();
        this.provider.langchange.subscribe(res => {            
            this.translate();
        }); 
    }

    translate() {
        if (!this.provider.getTranslatedItems()) {
            return;
        }
        const items = this.provider.getTranslatedItems().Items;
        const translation = items.filter((x: { Key: any; }) => x.Key === this.appTranslate);
        if (!!translation && !!translation.length) {
            this.el!.nativeElement.textContent = translation[0].Value;

        } else {
            this.el!.nativeElement.textContent = this.appTranslate;

        }
    }
    
}
